import { render, staticRenderFns } from "./InvPL_List.vue?vue&type=template&id=07c8bc6b"
import script from "./InvPL_List.vue?vue&type=script&lang=js"
export * from "./InvPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports